import React from "react";
import dynamic from "next/dynamic";

const ImageUI = dynamic(() => import("@/common/UI/Image"));

function SocialIcons(props) {
  const { customClass, iconColor, linkClass, siteConfig, customColor } = props;

  return (
    <>
      <ul className={customClass ? customClass : "inline-flex ml-10"}>
        {siteConfig?.twitter && (
          <li className={`mt-2 mr-2 ${linkClass}`}>
            <a
              href={siteConfig?.twitter}
              className="hover:text-themeHover align-middle"
              target="_blank"
              rel="noreferrer"
            >
              {/* <span
   className="iconify"
   data-width={26}
   data-icon="carbon:logo-twitter"
   color={iconColor || "black"}
 ></span> */}
              <ImageUI
                src={siteConfig?.twitterIcon?.webp}
                alt={siteConfig?.twitterIcon?.alt}
                title={siteConfig?.twitterIcon?.title}
                width={18}
                height={18}
                className={customColor ? "white-img" : ""}
              />
            </a>
          </li>
        )}

        {siteConfig?.facebook && (
          <li className={`mt-2 mr-2 ${linkClass}`}>
            <a
              href={siteConfig?.facebook}
              className="hover:text-themeHover align-middle"
              target="_blank"
              rel="noreferrer"
            >
              {/* <span
                className="iconify"
                data-width={24}
                data-icon="bx:bxl-facebook"
                color={iconColor || "black"}
              ></span> */}
              <ImageUI
                src={siteConfig?.facebookIcon?.webp}
                alt={siteConfig?.facebookIcon?.alt}
                title={siteConfig?.facebookIcon?.title}
                width={18}
                height={18}
                className={`object-contain ${customColor ? "white-img" : ""}`}
              />
            </a>
          </li>
        )}
        {siteConfig?.instagram && (
          <li className={`mt-2 ${linkClass} mr-0`}>
            <a
              href={siteConfig?.instagram}
              className="hover:text-themeHover align-middle"
              target="_blank"
              rel="noreferrer"
            >
              {/* <span
                className="iconify"
                data-width={24}
                data-icon="ant-design:instagram-outlined"
                color={iconColor || "black"}
              ></span> */}
              <ImageUI
                src={siteConfig?.instagramIcon?.webp}
                alt={siteConfig?.instagramIcon?.alt}
                title={siteConfig?.instagramIcon?.title}
                width={18}
                height={18}
                className={customColor ? "white-img" : ""}
              />
            </a>
          </li>
        )}
      </ul>
    </>
  );
}

export default SocialIcons;
